export default {
  title: 'China Chengda Engineering Co., Ltd.',
  title_ja: '中国成達エンジニアリング株式会社',
  title_zh: '中国成达工程股份有限公司',
  role: 'Safety Engineer',
  role_ja: '安全エンジニア',
  role_zh: '安全工程师',
  location: 'Mesaieed, Qatar',
  location_ja: 'カタール・メサイード',
  location_zh: '卡塔尔梅赛义德',
  period: 'Feb 2023 – Jul 2023',
  slug: 'chengda',
  summary: 'Led safety operations for a $200M PVC Powder Project, ensuring regulatory compliance and safe working conditions.',
  summary_ja: '2億ドルのPVC粉末プロジェクトの安全業務を指揮し、規制遵守と安全な作業環境を確保。',
  summary_zh: '领导2亿美元PVC粉末项目的安全运营，确保符合法规和安全的工作条件。',
  achievements: [
    'Obtained E-CPW safety permit through Qatar Energy\'s official certification program',
    'Oversaw all safety equipment procurement and logistics for both office and field operations',
    'Led a multicultural safety team (India & Pakistan) in daily TBTs and monthly emergency drills',
    'Monitored the issuance and execution of safety work permits across civil, electrical, and mechanical disciplines',
    'Drafted emergency response plans for the project office and Chinese staff camp',
    'Compiled weekly and monthly safety reports, and coordinated safety campaigns aligned with HQ',
    'Negotiated large-scale permit printing deals with local vendors',
    'Supported visa, travel, and medical document workflows for senior local staff'
  ],
  achievements_ja: [
    'カタールエネルギーの公式認証プログラムを通じてE-CPW安全許可証を取得',
    'オフィスとフィールド業務の両方の安全装備の調達と物流を監督',
    '多文化安全チーム（インド＆パキスタン）を率いて日々のTBTと月次緊急訓練を実施',
    '土木、電気、機械分野にわたる安全作業許可証の発行と実行を監視',
    'プロジェクトオフィスと中国人スタッフキャンプの緊急対応計画を起草',
    '週次および月次の安全報告書を作成し、本社に合わせた安全キャンペーンを調整',
    '地元ベンダーとの大規模な許可証印刷契約を交渉',
    '地元上級スタッフのビザ、旅行、医療文書の手続きをサポート'
  ],
  achievements_zh: [
    '通过卡塔尔能源官方认证计划获得E-CPW安全许可',
    '监督办公室和现场作业的所有安全设备采购和物流',
    '领导多文化安全团队（印度和巴基斯坦）进行日常工具箱讲话和月度应急演练',
    '监控土木、电气和机械学科的安全工作许可证的签发和执行',
    '为项目办公室和中国员工营地起草应急响应计划',
    '编制每周和每月安全报告，并协调与总部一致的安全活动',
    '与当地供应商洽谈大规模许可证打印交易',
    '支持高级当地员工的签证、旅行和医疗文件工作流程'
  ],
  tags: ['safety', 'engineering', 'international', 'energy'],
  metadata: {
    type: 'Engineering Project',
    type_ja: 'エンジニアリングプロジェクト',
    type_zh: '工程项目',
    field: 'Chemical Engineering',
    field_ja: '化学工学',
    field_zh: '化学工程',
    teamSize: 'Large (100+)',
    teamSize_ja: '大規模 (100人以上)',
    teamSize_zh: '大型 (100人以上)',
    role: 'Safety Engineer',
    role_ja: '安全エンジニア',
    role_zh: '安全工程师',
    projectValue: '$200M',
    projectValue_ja: '2億ドル',
    projectValue_zh: '2亿美元'
  },
  projects: [
    {
      name: 'QVC PVC Powder Project',
      name_ja: 'QVC PVC粉末プロジェクト',
      name_zh: 'QVC PVC粉末项目',
      value: '$200M',
      value_ja: '2億ドル',
      value_zh: '2亿美元'
    }
  ],
  // For future detailed content
  getContent: () => import('../content/chengda.md')
} 